import { Component, Input } from '@angular/core';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-confirmacao',
  templateUrl: './modal-confirmacao.component.html',
  styles: [],
})
export class ModalConfirmacaoComponent {
  @Input() public mensagem: string;
  @Input() public confirmarCallback: () => void;
  @Input() public negarCallback: () => void;

  public btConfirmacao: string = 'Sim';
  public btRecusa: string = 'Não';

  public readonly iconCofirmacao = faCheck;
  public readonly iconRecusa = faTimes;

  constructor(private activeModal: NgbActiveModal) {}

  public confirmar() {
    this.activeModal.dismiss('dismiss');
    this.confirmarCallback();
  }

  public fechar() {
    this.activeModal.dismiss('dismiss');
    if (this.negarCallback) {
      this.negarCallback();
    }
  }
}
